import { guessNumber, historyGuessNumber } from "api/game";
import { useMutation } from "react-query";

function useGuessNumber() {
  return useMutation(guessNumber, {
    onError: (err) => {
      console.log(err.message);
    },
  });
}

function useHistoryGuessNumber() {
  return useMutation(historyGuessNumber, {
    onError: (err) => {
      console.log(err.message);
    },
  });
}

export { useGuessNumber, useHistoryGuessNumber };
